<template>
	<div class="mobile-order-summary">
		<button
			class="mobile-order-summary__action"
			@click="visible = !visible"
		>
			<span>Show full order summary</span>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height="1em"
				viewBox="0 0 512 512"
				fill="currentColor"
				class="mobile-order-summary__icon"
				:class="{ '--active': visible }"
			>
				<path
					d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
				/>
			</svg>
			<span class="mobile-order-summary__price">{{
				priceBreakdown.total
			}}</span>
		</button>

		<CollapseTransition>
			<OrderSummary v-if="visible" />
		</CollapseTransition>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import CollapseTransition from '@component/UI/Transitions/CollapseTransition.vue';
import OrderSummary from '@component/user-backend/Checkout/V4/OrderSummary.vue';

export default {
	components: {
		CollapseTransition,
		OrderSummary,
	},

	data: () => ({
		visible: false,
	}),

	computed: mapGetters('checkout', ['priceBreakdown']),
};
</script>

<style lang="scss" scoped>
.mobile-order-summary {
	background: var(--white);
	border-bottom: 1px solid var(--gray-200);
	padding: 0 15px;
	margin-bottom: var(--size-lg);

	&__action {
		align-items: center;
		background: transparent;
		border: 0;
		color: var(--blue-500);
		display: flex;
		display: flex;
		font-family: inherit;
		font-weight: 600;
		gap: var(--size-sm);
		gap: var(--size-sm);
		height: 50px;
		margin: 0;
		padding: 0;
		width: 100%;

		&:focus {
			color: var(--blue-700);
		}
	}

	&__price {
		margin-left: auto;
	}

	> div {
		margin-bottom: 15px;
	}

	&__icon {
		transition: transform 300ms ease;

		&.--active {
			transform: rotate(180deg);
		}
	}
}
</style>
